module.exports = __webpack_public_path__ + "static/karma-996e69c8b9a0773d1d2cad292e7d6e6f.png";